import { render } from "./TerminosCondiciones.vue?vue&type=template&id=991e562e&scoped=true"
const script = {}

import "./TerminosCondiciones.vue?vue&type=style&index=0&id=991e562e&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-991e562e"]])

export default __exports__